// extracted by mini-css-extract-plugin
module.exports = {"root":"FollowUs_root__3sI-4","caption":"FollowUs_caption__YF0cy","linkHolder":"FollowUs_linkHolder__1RtD7","link":"FollowUs_link__1bGk-"};
    if(module.hot) {
      // 1586964019407
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  